import { Link } from '@billy/design-system'
import { ReactNode } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { PeriodMode } from '../../../../../../../../enums/periodMode'
import { useInvoicesList } from '../../../../context/invoicesList'
import { useInvoicesListData } from '../../../../context/invoicesListData'
import { useInvoicesListFilters } from '../../../../context/invoicesListFilters'

export const InvoicesTableEmptyRowInfo = (): ReactNode => {
  const { t } = useTranslation()
  const { hasInvoices } = useInvoicesListData()
  const { newDocumentUrl } = useInvoicesList()
  const [filters] = useInvoicesListFilters()

  if (!hasInvoices) {
    return <Trans i18nKey="external_invoices.invoices_list.empty_state" components={[<Link to={newDocumentUrl} />]} />
  }

  if (filters.searchQuery) {
    return t('external_invoices.invoices_list.no_results.search')
  }

  if (filters.period && filters.period !== PeriodMode.All) {
    return t('external_invoices.invoices_list.no_results.period')
  }

  return t('table.empty_message')
}
